var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragdots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7935 2.39672C12.7935 3.1691 12.1691 3.80041 11.3967 3.80041C10.6244 3.80041 10 3.18167 10 2.41068V2.39672C10 1.62433 10.6244 1 11.3967 1C12.1691 1 12.7935 1.62433 12.7935 2.39672Z",
    fill: "#323A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7935 7.99702C12.7935 8.7694 12.1691 9.39932 11.3967 9.39932C10.6244 9.39932 10 8.78197 10 8.00959V7.99702C10 7.22464 10.6244 6.6003 11.3967 6.6003C12.1691 6.6003 12.7935 7.22464 12.7935 7.99702Z",
    fill: "#323A46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7934 13.5962C12.7934 14.3686 12.1691 14.9999 11.3967 14.9999C10.6243 14.9999 10 14.3812 10 13.6088V13.5962C10 12.8239 10.6243 12.1995 11.3967 12.1995C12.1691 12.1995 12.7934 12.8239 12.7934 13.5962Z",
    fill: "#323A46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79346 2.39672C5.79346 3.1691 5.16913 3.80041 4.39674 3.80041C3.62436 3.80041 3.00003 3.18167 3.00003 2.41068L3.00003 2.39672C3.00003 1.62433 3.62436 1 4.39674 1C5.16913 1 5.79346 1.62433 5.79346 2.39672Z",
    fill: "#323A46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79346 7.99702C5.79346 8.7694 5.16913 9.39932 4.39674 9.39932C3.62436 9.39932 3.00003 8.78197 3.00003 8.00959L3.00003 7.99702C3.00003 7.22464 3.62436 6.6003 4.39674 6.6003C5.16913 6.6003 5.79346 7.22464 5.79346 7.99702Z",
    fill: "#323A46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79343 13.5962C5.79343 14.3686 5.1691 14.9999 4.39672 14.9999C3.62433 14.9999 3 14.3812 3 13.6088L3 13.5962C3 12.8239 3.62433 12.1995 4.39671 12.1995C5.1691 12.1995 5.79343 12.8239 5.79343 13.5962Z",
    fill: "#323A46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragdots);
export default __webpack_public_path__ + "static/media/Dragdots.f6da41c9e0c4a07d0e52e6d30cb7d63a.svg";
export { ForwardRef as ReactComponent };